import React from 'react';

import Footer1 from './Footer1';
import Footer2 from './Footer2';

const Footer = () => (
  <React.Fragment>
    <Footer1 />
    <Footer2 />
  </React.Fragment>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Footer/Footer.js